import React from 'react';
import { cn } from '@/lib/utils';

export type AlertVariant = 'info' | 'success' | 'warning' | 'error';

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: AlertVariant;
  title?: string;
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ className, variant = 'info', title, children, ...props }, ref) => {
    const variants: Record<AlertVariant, string> = {
      info: 'bg-secondary/30 border-foreground/10 text-foreground',
      success: 'bg-success/10 border-success/30 text-foreground',
      warning: 'bg-primary/10 border-primary/30 text-foreground',
      error: 'bg-destructive/10 border-destructive/30 text-foreground',
    };

    return (
      <div
        ref={ref}
        role="status"
        className={cn('w-full rounded-md border p-4 text-sm', variants[variant], className)}
        {...props}
      >
        {title && <div className="font-bold mb-1">{title}</div>}
        <div className="text-muted-foreground [&_a]:text-foreground [&_a]:underline [&_a]:underline-offset-2">
          {children}
        </div>
      </div>
    );
  }
);
Alert.displayName = 'Alert';



